import { SuccessReturnBody, getSuccessReturnBody } from '../general';

export interface ProjectShort {
    id: number;
    name: string;
}

export interface ProjectsShortRequest {
    CompanyId?: number;
}

export interface ProjectsShortResponse extends Array<ProjectShort> {}

export function getProjectsShortSuccess(projectsShortList: ProjectShort[]): SuccessReturnBody {
  return getSuccessReturnBody(projectsShortList);
}
